<template>
  <div>
    <v-btn
      icon
      @click.stop="openDialog()"
    >
      <v-icon color="primary">mdi-cloud-upload</v-icon>
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="640"
    >
      <v-card>
        <v-card-title class="headline">ポジショニングマップを5日間だけ公開することができます。<br>
        Twitterなどを利用して、友達等に限定公開URLを教えることで、あなたのこのポジショニングマップを簡単に見せることができます。（休止中）</v-card-title>

        <v-card-text>
          <p>限定公開URL（以下URL）を発行します。以下をご確認の上、URLを取得してください。</p>
          <ol>
            <li>URLは、閲覧専用のポジショニングマップを表示する画面です。ダウンロードもできません。</li>
            <li>Note表示機能（クリックで表示）をつけることができます。</li>
            <li>5日後に「URLのポジショニングマップ」は自動的に削除され、見ることができなくなります。</li>
            <li>「URLのポジショニングマップ」と「あなたのこのポジショニングマップ」は異なるデータで、リンクされていません。</li>
            <li>「あなたのこのポジショニングマップ」は今まで通り編集などできますが、「URLのポジショニングマップ」は今の状態のまま変わりません。</li>
            <li>URLは何度でも取得することができます。</li>
            <li>著作権などには十分注意してご利用ください。</li>
            <li>公開延長を希望のご利用者様は、最長1カ月程度の公開は可能です。その場合は、ご利用者様のTwitterに該当のポジショニングマップを公開してから、そのアカウントで、<a href="https://twitter.com/AssistGoal" class="twitter-follow-button" data-show-count="false">@AssistGoal</a>まで公開期間延長の希望連絡をいただけますでしょうか。</li>
          </ol>
        </v-card-text>

        <!--
        <p style="font-size: 20px; text-align: center;">Note表示機能をつけますか？</p>
        <div
          class="mb-4"
          align="center"
        >
          <v-btn-toggle
            v-model="viewNote"
            color="primary"
          >
            <v-btn value="false" style="width: 150px;">
              つけない
            </v-btn>
            <v-btn value="true" style="width: 150px;">
              つける
            </v-btn>
          </v-btn-toggle>
        </div>

        <p style="font-size: 24px; text-align: center;">限定公開URLを取得しますか？</p>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey lighten-2"
            dark
            depressed
            large
            @click="dialog = false"
          >
            {{ $t('Workspace.setting.noButton') }}
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            dark
            depressed
            large
            @click.stop="createPublicDiagram()"
          >
            {{ $t('Workspace.setting.yesButton') }}
          </v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
        -->
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="urlDialog"
      max-width="640"
      persistent
    >
      <v-card>
        <v-card-title class="headline">https://www.positioning-map.com{{ publicUrl }}</v-card-title>
        <v-card-text
          class="mt-24"
        >
          <v-btn
            color="primary"
            dark
            depressed
            :href="publicUrl"
            target="_blank"
          >
            <v-icon>mdi-launch</v-icon>
            限定公開URLを見てみる
          </v-btn>
        </v-card-text>

        <social-sharing
          :url="'https://www.positioning-map.com' + publicUrl"
          :title="'ポジショニングマップ: ' + this.sheet.name"
          description="ポジショニングマップ.COMでつくったポジショニングマップです。"
          quote=""
          hashtags="ポジショニングマップ,ポジショニングマップ.COM"
          twitter-user=""
          inline-template>
          <div
            class="d-flex justify-center pb-4"
          >
            <network network="twitter">
              <i class="mdi mdi-twitter" style="color: #1DA1F2; font-size: 64px;"></i>
            </network>
          </div>
        </social-sharing>

        <v-card-text>
          <p>限定公開URLを発行しました。この画面を閉じるとURLがわからなくなりますので、上記URLをコピーするなどしてください。万一わからなくなったとしても、再度、別の限定公開URLを取得することは可能です。</p>
          <ul>
            <li>限定公開URLは、閲覧専用のポジショニングマップを表示する画面です。</li>
            <li>Note表示機能をつけている場合、ObjectをクリックするとNoteが表示されます。再度クリックすると閉じます。</li>
            <li>5日後に自動的に削除され、見ることができなくなります。</li>
          </ul>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="urlDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/database'
const db = firebase.firestore()

export default {
  props: ['sheet'],
  data () {
    return {
      dialog: false,
      urlDialog: false,
      publicUrl: '',
      viewNote: false
    }
  },
  methods: {
    openDialog () {
      // イベントカテゴリ, イベントアクション, イベントラベル
      this.$ga.event('header', 'click', 'publish')
      this.dialog = true
    },
    createPublicDiagram () {
      // sheet validation
      if (
        !this.sheet.objects ||
        !this.sheet.name ||
        !this.sheet.time ||
        !this.sheet.ver ||
        !this.sheet.copyright
      ) {
        alert('Sorry, data is corrupt.')
        this.dialog = false
        return false
      }

      // 現在
      const createdAt = firebase.firestore.Timestamp.now()
      // 5日後
      const deleteAt = firebase.firestore.Timestamp.fromMillis(createdAt.toMillis() + 86400000 * 5)

      db.collection('publics').add({
        sheet: JSON.stringify(this.sheet),
        createdAt: createdAt,
        deleteAt: deleteAt,
        viewNote: (this.viewNote === 'true')
      }).then(response => {
        const publicNo = response.id
        if (publicNo) {
          this.publicUrl = '/public/' + publicNo
          this.dialog = false
          this.urlDialog = true
        } else {
          alert('[createPublicDiagram db.collection response Error] Sorry, application error.')
          return false
        }
      }).catch(error2 => {
        alert('[createPublicDiagram db.collection Error] Sorry, application error.')
        return false
      })
    }
  }
}
</script>
